export default __webpack_public_path__ + "static/media/edit_icon.b5517885.svg";